import React from 'react';
import {ISearchResultItem} from '../../search-result/search-result-item.interface';
import {IConfigFieldDefinition} from '../../../configurations-areas/fields-definitions/config-field-definition-base';

export class FoundConfigurationField implements ISearchResultItem {
    constructor(private _field: IConfigFieldDefinition) {

    }

    get key(): any {
        return this._field.configurationKey;
    }

    render(): React.ReactNode {
        return this._field.render();
    }
}